/****************************************************
 * Module Name:  apiDocs.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Constants from "../constants";
import CustomerAPISettingsProxy from "../proxy/manager/customerAPISettingsProxy";
import NoPermission from "../../components/common/noPermission";
import { Box, CircularProgress } from "@mui/material";
import PageTitle from "../../components/common/pageTitle";

const ApiDocs = () => {
  const [local_Permission, setLocal_Permission] = useState(false);
  const [circularProgress, setCircularProgress] = useState(true);
  useEffect(() => {
    PageTitle("API_DOCS");
    checkPermission();
  }, []);

  const checkPermission = () => {
    if (Constants.loggedInUser.usertype === "E") {
      setCircularProgress(false);
      setLocal_Permission(true);
    } else if (Constants.loggedInUser.usertype === "C") {

      CustomerAPISettingsProxy.CheckCustomerApiEnabled(Constants.loggedInUser.id, (response) => {
        if (response) {
          setCircularProgress(false);
          setLocal_Permission(response);
        } else {
          setCircularProgress(false);
        }
      })
    } else if (Constants.loggedInUser.usertype !== "B") {
      setCircularProgress(false);
      setLocal_Permission(false);
    }
  };

  return (
    <>
      <br />
      {circularProgress ?
        <Box sx={{
          height: "80vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <CircularProgress size="4rem" />
        </Box>
        : !local_Permission ? <NoPermission /> : (<iframe
          src="/swagger.html"
          title="API Documentation"
          style={{ width: "100%", height: "100vh", border: "none" }}
        />)}
    </>
  );
};

export default ApiDocs;
